export {
  Route,
  Link,
  Switch,
  HashRouter as Router,
} from 'react-router-dom'